import { Component } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { SearchReservationsServices } from '../../../services/searchsReservation';
import { SearchServices } from '../../../services/searchs';
import { ReservationsServices } from '../../../reservation/services';
import { CustomersServices } from '../../../customers/services';
import { EmailServices } from '../../../services/emailServices';

/**
 * Generated class for the CompCreateReservationPage page.
 * Component que carga estilo modal para crear/editar una reserva
 *
 */

@Component({
  selector: 'create-reservation',
  templateUrl: 'create-reservation.html',
})
export class CompCreateReservationPage {

  public form: FormGroup;
  public form_inputs_default_safe: any[] = [];
  public form_inputs_safe: any[] = [];
  public show_advanced_options: boolean = false;
  update_state: boolean = false;
  reservation: any = [];
  date: any;
  event: any;
  covermanager: boolean = false;
  reservation_config: any = [];
  selectedValuesCheckbox: any = [];

  constructor(public dishServices: DishServices,
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    public searchServices: SearchServices,
    public searchReservationsServices: SearchReservationsServices,
    public reservationsServices: ReservationsServices,
    public customersServices: CustomersServices,
    public emailServices: EmailServices) {
    //get nav params
    this.update_state = this.navParams.get('update_state');
    this.reservation = this.navParams.get('reservation');
    this.reservation_config = this.navParams.get('reservation_config');
    this.date = this.navParams.get('date');
    this.event = this.navParams.get('event');
    this.searchServices.customer_info = {};
  }

  ionViewWillEnter() {
    this.initForm();
  }

  async ngOnInit() {
    this.initForm();
    if (this.update_state) {
      this.globals.GAtrackView('Reservations', 'Reservations - View', this.globals.restaurant.email, 'View', 'View reservation', 'Reservations', this.reservation.name);
    }
  }

  initForm() {
    const formInputsDefault = (this.reservation_config && this.reservation_config.form_inputs_default) ? this.reservation_config.form_inputs_default : [];
    const formInputs = (this.reservation_config && this.reservation_config.form_inputs) ? this.reservation_config.form_inputs : [];
    //format basic input forms
    if (this.update_state) {
      //
      var form_update = {
        name: [this.reservation.name, Validators.compose([Validators.required])],
        date: [this.reservation.date, Validators.compose([Validators.required])],
        stripe: this.reservation.stripe,
        hour: [this.reservation.hour, Validators.compose([Validators.required])],
        adults: [this.reservation.adults, Validators.compose([Validators.required])],
        children: this.reservation.children,
        email: this.reservation.email,
        message: this.reservation.message,
        phone: this.reservation.phone,
        address: this.reservation.address,
        UID_CLIENT: this.reservation.UID_CLIENT,
        UID_TABLE: this.globals.ifVarEmpty(this.reservation.UID_TABLE),
        date_order: this.globals.ifVarEmpty(this.reservation.date_order),
        customer_table: this.globals.ifVarEmpty(this.reservation.customer_table),
        state: this.reservation.state || 'accepted'
      };
    } else {
      var form_create = {
        name: ['', Validators.compose([Validators.required])],
        date: [this.date, Validators.compose([Validators.required])],
        stripe: 1,
        hour: ['', Validators.compose([Validators.required])],
        adults: [0, Validators.compose([Validators.required])],
        children: 0,
        email: '',
        message: '',
        phone: '',
        address: '',
        UID_CLIENT: '',
        UID_TABLE: '',
        customer_table: '',
        state: "accepted",
      };
    }
    //add inputs default
    for (let form_input_default of formInputsDefault) {
      if (!form_input_default || !form_input_default.input_name) {
        continue;
      }
      if (form_input_default.active) {
        if (form_input_default.name === 'Teléfono') {
          form_input_default.name = 'general-telefono';
        } else if (form_input_default.name === 'Dirección') {
          form_input_default.name = 'general-direccion';
        }
        if (this.update_state) {
          form_update[form_input_default.input_name] = this.reservation[form_input_default.input_name];
        } else {
          form_create[form_input_default.input_name] = '';
        }
      }
    }
    //add inputs optional en caso creación
    if (!this.update_state) {
      for (let form_input of formInputs) {
        if (!form_input || !form_input.input_name) {
          continue;
        }
        if (form_input.active) {
          var _options;
          if (form_input.name === 'Campo de comentario') {
            form_input.name = 'general-comentario';
          }
          form_input.name = (form_input.name || '').trim();
          if (form_input.name) {
            form_input.name = this.translate.instant(form_input.name);
          }
          if (form_input.type == 'text') {
            form_create[form_input.input_name] = '';
          } else if (form_input.type === 'select') {
            form_create[form_input.input_name] = '';
            _options = (form_input.options || '').split(";");
            form_input._options = _options.map(option => option ? this.translate.instant(option) : option);
          } else {//checkbox
            _options = (form_input.options || '').split(";");
            form_input._options = _options.map(option => option ? this.translate.instant(option) : option);
            form_input.selectedOptions = [];
          }
        }
      }
    }
    this.form_inputs_default_safe = formInputsDefault.filter(input => input && input.input_name);
    this.form_inputs_safe = formInputs.filter(input => input && input.input_name && (input.name || '').trim() !== '');

    //formBuilder create/update
    if (this.update_state) {
      //set search services
      this.searchServices.customer_data = this.reservation.name;
      this.searchServices.selectedPersonId = this.reservation.UID_CLIENT;
      this.searchReservationsServices.tables_data = this.reservation.customer_table;
      this.searchReservationsServices.selectedTableId = this.reservation.UID_TABLE;
      //formBuilder
      this.form = this.formBuilder.group(form_update);
      if (this.reservation.covermanager_id == undefined) {
        this.covermanager = false;
      } else {
        this.covermanager = true;
      }
    } else {
      this.form = this.formBuilder.group(form_create);
      this.covermanager = false;
    }
    //Guardamos el form en searchService
    this.searchServices.form = this.form;
    this.searchReservationsServices.form = this.form;
  }

  close() {
    this.viewCtrl.dismiss();
  }

  change_show_advanced_options() {
    this.show_advanced_options = !this.show_advanced_options;
  }

  activeState(state) {
    let cssClasses = {
      'btn-outline-pending': false,
      'btn-outline-accepted': false,
      'btn-outline-in-table': false,
      'btn-outline-finished': false,
      'btn-outline-denied': false,
      'btn-outline-not-presented': false,
      'btn-outline-queue': false,
    };

    switch (state) {
      case 'pending':
        cssClasses['btn-outline-pending'] = true;
        break;
      case 'accepted':
        cssClasses['btn-outline-accepted'] = true;
        break;
      case 'in_table':
        cssClasses['btn-outline-in-table'] = true;
        break;
      case 'finished':
        cssClasses['btn-outline-finished'] = true;
        break;
      case 'denied':
        cssClasses['btn-outline-denied'] = true;
        break;
      case 'not_presented':
        cssClasses['btn-outline-not-presented'] = true;
        break;
      case 'queue':
        cssClasses['btn-outline-queue'] = true;
        break;
      case 'anulated':
        cssClasses['btn-outline-denied'] = true;
        break;
      default:
        cssClasses['btn-outline-pending'] = true;
    }

    return cssClasses;
  }

  changeState(state) {
    this.form.get('state').setValue(state);
  }

  toggleCheckbox(input_name, value) {
    if (!this.selectedValuesCheckbox[input_name]) {
      this.selectedValuesCheckbox[input_name] = [];
    }

    if (this.selectedValuesCheckbox[input_name].includes(value)) {
      this.selectedValuesCheckbox[input_name] =
        this.selectedValuesCheckbox[input_name].filter(
          (val) => val !== value
        );
    } else {
      this.selectedValuesCheckbox[input_name] = [
        ...this.selectedValuesCheckbox[input_name],
        value,
      ];
    }
  }

  submitForm() {
    document.querySelector('form').dispatchEvent(new Event('submit'));
  }

  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
      //Vaciamos el buscador de clientes
      this.searchServices.customer_data = '';
      this.searchReservationsServices.tables_data = '';
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-introduce-todos-datos-obligatorios'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }


  async insert() {
    try {
      //si cliente no seleccionado con el buscador "selectedPersonId" crearlo
      var uid_client = this.searchServices.selectedPersonId;
      if (this.searchServices.selectedPersonId === '') {
        uid_client = await this.customersServices.addNewCustomer({
          'UID_RESTAURANT': this.globals.restaurant_uid,
          'name': this.form.value.name,
          'business_name': '',
          'business_number': '',
          'email': this.globals.ifVarEmpty(this.form.value.email),
          'phone': this.globals.ifVarEmpty(this.form.value.phone),
          'address': this.globals.ifVarEmpty(this.form.value.address),
          'note': '',
          'created_at': new Date()
        });
      }
      var uid_table = this.searchReservationsServices.selectedTableId;
      //
      var reservation_data = {
        UID_RESTAURANT: this.globals.restaurant_uid,
        name: this.form.value.name,
        date: this.form.value.date,
        stripe: this.getStripeByHour(this.form.value.hour),
        hour: this.form.value.hour,
        adults: this.form.value.adults,
        children: this.form.value.children,
        email: this.form.value.email,
        message: this.form.value.message,
        phone: this.form.value.phone,
        address: this.form.value.address,
        delete: false,
        UID_CLIENT: uid_client,
        UID_TABLE: uid_table,
        state: this.form.value.state,
        date_order: this.reservationsServices.returnOrderDate(this.form.value.date, this.form.value.hour),
        customer_table: this.form.value.customer_table,
        online: false,
        updated_user: this.globals.user_name
      };
      //añadimos los campos opcionales
      for (let form_input of this.reservation_config.form_inputs) {
        if (form_input.active) {
          if (form_input.type != 'checkbox') {//text+select
            if (this.form.value[form_input.input_name] && this.form.value[form_input.input_name] != '') {
              reservation_data.message = reservation_data.message + form_input.name +
                ": " +
                this.form.value[form_input.input_name] +
                "\n";
            }
          } else {//checkbox
            if (this.selectedValuesCheckbox[form_input.input_name]) {
              reservation_data.message =
                reservation_data.message +
                form_input.name +
                ": " +
                this.selectedValuesCheckbox[
                  form_input.input_name
                ].toString() +
                "\n";
            }
          }
        }
      }
      //

      this.reservationsServices.afs.collection('reservations')
        .add(reservation_data)
        .then(doc => {
          this.globals.GAtrackView('Reservations', 'Reservations - Create', this.globals.restaurant.email, 'Create/Update', 'Create reservation', 'Reservations', this.form.value.name);
          reservation_data['UID'] = doc.id;
          //send mail
          if (this.form.value.state === 'pending') {
            this.emailServices.sendEmailReservation('reservation_pending', reservation_data);
          } else if (this.form.value.state === 'accepted') {
            this.emailServices.sendEmailReservation('reservation_accepted', reservation_data);
          } else if (this.form.value.state === 'denied') {
            this.emailServices.sendEmailReservation('reservation_denied', reservation_data);
          }
          this.close();
        });
    } catch (error) {
      this.close();
    }
  }

  update() {
    try {
      var reservation_data = {
        UID_RESTAURANT: this.globals.restaurant_uid,
        name: this.form.value.name,
        date: this.form.value.date,
        stripe: this.getStripeByHour(this.form.value.hour),
        hour: this.form.value.hour,
        adults: this.form.value.adults,
        children: this.form.value.children,
        email: this.form.value.email,
        message: this.form.value.message,
        phone: this.form.value.phone,
        address: this.form.value.address,
        UID_CLIENT: this.form.value.UID_CLIENT,
        UID_TABLE: this.form.value.UID_TABLE,
        state: this.form.value.state,
        date_order: this.reservationsServices.returnOrderDate(this.form.value.date, this.form.value.hour),
        customer_table: this.form.value.customer_table,
        online: this.reservation.online || false,
        delete: this.reservation.delete || false,
        updated_user: this.globals.user_name
      };
      //add doc
      this.reservationsServices.afs.collection('reservations').doc(this.reservation.UID).update(reservation_data).then(() => {
        this.globals.GAtrackView('Reservations', 'Reservations - Update', this.globals.restaurant.email, 'Create/Update', 'Update reservation', 'Reservations', this.form.value.name);
        //sendEmail
        if (this.form.value.state != this.reservation.state) {
          reservation_data['UID'] = this.reservation.UID;
          //pending
          if (this.form.value.state === 'pending') {
            this.emailServices.sendEmailReservation('reservation_pending', reservation_data);
          }
          //accepted
          if (this.form.value.state === 'accepted') {
            this.emailServices.sendEmailReservation('reservation_accepted', reservation_data);
          }
          //denied
          if (this.form.value.state === 'denied') {
            this.emailServices.sendEmailReservation('reservation_denied', reservation_data);
          }
        }
        this.close();
      });
    } catch (error) {
      this.close();
    }
  }


  getStripeByHour(hour) {
    var stripe = 1;
    for (let i = 0; i < this.reservation_config.form_stripes.length; i++) {
      const franja = this.reservation_config.form_stripes[i];
      const franjaStart = franja.start;
      const franjaEnd = franja.end;

      // Ajusta el formato de las horas para compararlas
      const horaInicio = new Date(`2000-01-01T${franjaStart}`);
      const horaFin = new Date(`2000-01-01T${franjaEnd}`);
      const horaActual = new Date(`2000-01-01T${hour}`);

      // Compara las horas teniendo en cuenta el nuevo día
      if (
        (horaActual >= horaInicio && horaActual <= horaFin) ||
        (horaFin <= horaInicio && (horaActual >= horaInicio || horaActual <= horaFin))
      ) {
        // Asigna el número de la franja a la hora
        if (i == 0) {
          stripe = 1;
        } else if (i == 1) {
          stripe = 2;
        }
        else if (i == 2) {
          stripe = 3;
        }
        break;
      }
    }
    return stripe;
  }

  fullHeight(value) {
    if (value) {
      let cssClasses = {
        'height-100': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'height-100': false,
      }
      return cssClasses;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/popups/create-reservation/create-reservation.ts